import { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext(null);

const load = (k, def) => {
  try {
    const v = localStorage.getItem(k);
    return v === null ? def : JSON.parse(v);
  } catch {
    return def;
  }
};

export function SettingsProvider({ children }) {
  const [theme, setTheme] = useState(() => load("fw_theme", "dark"));
  const [dyslexia, setDyslexia] = useState(() => load("fw_dyslexia", false));
  const [fontScale, setFontScale] = useState(() => load("fw_fontscale", 1));
  const [focusMode, setFocusMode] = useState(() => load("fw_focus", true));
  const [reduceMotion, setReduceMotion] = useState(() => load("fw_reduce", false));
  const [translation, setTranslation] = useState(() => load("fw_translation", "NLT"));
  const [atmosphere, setAtmosphere] = useState(() => load("fw_atmosphere", "off"));

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    root.classList.toggle("dyslexia", dyslexia);
    root.classList.toggle("reduce-motion", reduceMotion);
    localStorage.setItem("fw_theme", JSON.stringify(theme));
    localStorage.setItem("fw_dyslexia", JSON.stringify(dyslexia));
    localStorage.setItem("fw_focus", JSON.stringify(focusMode));
    localStorage.setItem("fw_reduce", JSON.stringify(reduceMotion));
    localStorage.setItem("fw_fontscale", JSON.stringify(fontScale));
    localStorage.setItem("fw_translation", JSON.stringify(translation));
    localStorage.setItem("fw_atmosphere", JSON.stringify(atmosphere));
  }, [theme, dyslexia, fontScale, focusMode, reduceMotion, translation, atmosphere]);

  const value = {
    theme, setTheme,
    dyslexia, setDyslexia,
    fontScale, setFontScale,
    focusMode, setFocusMode,
    reduceMotion, setReduceMotion,
    translation, setTranslation,
    atmosphere, setAtmosphere,
    toggleTheme: () => setTheme((t) => (t === "dark" ? "light" : "dark")),
  };
  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
